module.exports = __webpack_public_path__ + "static/media/food-fruit-healthy-svgrepo-com.756d9135.svg";